<template>
  <div class="flex flex-col md:flex-row">
    <div class="flex flex-col">
      <div class="flex flex-row py-1">
        <div class="flex items-center">
          <XIcon v-if="!lowerCase" class="text-brand-mid-gray mr-1 w-7 h-7" />
          <CheckIcon v-else class="text-brand-green mr-1 w-7 h-7" />
        </div>

        <div class="flex items-center">
          <p
            :class="[
              'italic',
              lowerCase ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            One lowercase character
          </p>
        </div>
      </div>
      <div class="flex flex-row py-1">
        <div class="flex items-center">
          <XIcon v-if="!upperCase" class="text-brand-mid-gray mr-1 w-7 h-7" />
          <CheckIcon v-else class="text-brand-green mr-1 w-7 h-7" />
        </div>
        <div class="flex items-center">
          <p
            :class="[
              'italic',
              upperCase ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            One uppercase character
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:ml-3">
      <div class="flex flex-row py-1">
        <div class="flex items-center">
          <XIcon v-if="!oneNumber" class="text-brand-mid-gray mr-1 w-7 h-7" />
          <CheckIcon v-else class="text-brand-green mr-1 w-7 h-7" />
        </div>

        <div class="flex items-center">
          <p
            :class="[
              'italic',
              oneNumber ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            One number
          </p>
        </div>
      </div>
      <div class="flex flex-row py-1">
        <div class="flex items-center">
          <XIcon v-if="!charMin" class="text-brand-mid-gray mr-1 w-7 h-7" />
          <CheckIcon v-else class="text-brand-green mr-1 w-7 h-7" />
        </div>

        <div class="flex items-center">
          <p
            :class="[
              'italic',
              charMin ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            8 characters minimum
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { XIcon, CheckIcon } from "@heroicons/vue/outline"

export default {
  components: {
    XIcon,
    CheckIcon
  },
  props: {
    password: {
      type: String,
      required: true
    }
  },
  computed: {
    charMin() {
      return !(this.password.length < 8)
    },
    lowerCase() {
      return this.password.match(/[a-z]/) !== null
    },
    upperCase() {
      return this.password.match(/[A-Z]/) !== null
    },
    oneNumber() {
      return this.password.match(/\d/) !== null
    },
    isValid() {
      return this.lowerCase && this.upperCase && this.oneNumber && this.charMin
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
